
import {API_ENDPOINT, AUTH_HEADERS} from "../../util/constants";
import {RSAA} from "redux-api-middleware";
import * as types from "../types/index";
import {handleUnauthorizedAccess} from "../../util/utility";

export function reportBroadcast(token, api_token, broadcast_id, data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/report-broadcast/${broadcast_id}?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
            types: [types.REPORT_BROADCAST_REQUEST, types.REPORT_BROADCAST_RECEIVE, {
                type: types.REPORT_BROADCAST_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetReportBroadcast = () => ({
    type: types.RESET_REPORT_BROADCAST,
    payload: null
});